export default __webpack_public_path__ + "static/media/1052.ac36fd73.png";